import {type EdgeProps, getSmoothStepPath, useInternalNode} from '@xyflow/react'
import React from 'react'

import {getEdgeParams} from '../helpers'

export const FloatingEdge: React.FC<EdgeProps> = ({id, source, target, markerEnd, style}) => {
  const sourceNode = useInternalNode(source)
  const targetNode = useInternalNode(target)

  if (!sourceNode || !targetNode) return null

  const {sx, sy, tx, ty, sourcePos, targetPos} = getEdgeParams(sourceNode, targetNode)

  const [edgePath] = getSmoothStepPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetX: tx,
    targetY: ty,
    targetPosition: targetPos
  })

  return (
    <>
      <path
        d={edgePath}
        className="react-flow__edge-interaction"
        style={{strokeWidth: 12, stroke: 'transparent', fill: 'none'}}
      />
      <path
        id={id}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        style={style}
      />
    </>
  )
}
